import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { FileText, Download } from "lucide-react";
import { api, fmtError, BACKEND_URL } from "@/lib/api";
import { fmtEUR, fmtDate } from "@/constants/labels";

const TYPE = { acompte: "Acompte", situation: "Situation", solde: "Solde", retenue: "Retenue libérée" };

/** Espace artisan — commissions dues et factures Factur-X de la plateforme. */
export const MesCommissions = () => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/commissions").then((r) => setD(r.data)).catch((e) => toast.error(fmtError(e))); }, []);
  if (!d) return null;
  return (
    <div className="card p-4 mt-6" data-testid="mes-commissions">
      <div className="flex items-baseline justify-between flex-wrap gap-2">
        <h2 className="text-lg font-semibold text-[#1F2933]">Commissions plateforme</h2>
        <span className="text-sm text-[#3E4C59]">Dû : <b data-testid="mes-commissions-total">{fmtEUR(d.total_du_ht)} HT</b> ({fmtEUR(d.total_du_ttc)} TTC) — en attente de prélèvement</span>
      </div>
      <p className="text-xs text-[#3E4C59] mt-1">Une commission est due sur chaque versement validé. Elle sera prélevée sur le versement libéré : aucun paiement à effectuer de votre part à réception de la facture.</p>
      {d.items.length === 0 ? <div className="text-sm text-[#3E4C59] mt-3">Aucune commission pour le moment.</div> : (
        <div className="overflow-x-auto mt-3"><table className="table-compact w-full text-sm">
          <thead><tr><th>Date</th><th>Commande</th><th>Versement</th><th>Base HT</th><th>Commission</th><th>Net perçu</th><th>Facture</th></tr></thead>
          <tbody>{d.items.map((c) => (
            <tr key={c.id} data-testid={`mes-commission-${c.id}`}>
              <td>{fmtDate(c.created_at)}</td><td>{c.commande_numero}</td><td>{TYPE[c.versement_type]}</td>
              <td className="tabular-nums">{fmtEUR(c.base_ht)}</td>
              <td className="tabular-nums">{fmtEUR(c.commission_ht)} HT <span className="text-[#3E4C59]">({fmtEUR(c.commission_ttc)} TTC)</span></td>
              <td className="tabular-nums font-semibold text-[#1B7F4B]">{fmtEUR(c.net_percu)}</td>
              <td>{c.facture_url ? <a href={`${BACKEND_URL}${c.facture_url}`} target="_blank" rel="noreferrer" className="btn-outline text-xs inline-flex" data-testid={`mes-commission-pdf-${c.id}`}><FileText size={12} /> {c.facture_numero}</a> : <span className="badge-muted" title="Facture en préparation">à venir</span>}</td>
            </tr>
          ))}</tbody>
        </table></div>
      )}
      {d.items.some((c) => c.facture_url) && <div className="text-[11px] text-[#3E4C59] mt-2 inline-flex items-center gap-1"><Download size={11} /> Factures au format Factur-X (PDF + XML EN 16931), ajoutez <code>?format=xml</code> pour le XML seul.</div>}
    </div>
  );
};
